import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { LinqFormsModule } from '@app/shared/forms/forms.module';
import { ImportClearedChecksComponent } from './bank-recon/import-cleared-checks/import-cleared-checks.component';
import { ImportClearedChecksService } from './bank-recon/services/import-cleared-checks.service';
import { CashManagementRoutingModule } from './cash-management-routing.module';
import { CashManagmentSchoolAccountingSharedModule } from './cash-management-sa-shared.module';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CashManagementRoutingModule,
		LinqFormsModule,
		CashManagmentSchoolAccountingSharedModule,
		ImportClearedChecksComponent,
	],
	providers: [ImportClearedChecksService],
})
export class CashManagementModule {}
